'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$103() {
  this.c28 = null;
  this.c29 = false;
}
export { $c_Lpresto_types$$anon$103 as $c_Lpresto_types$$anon$103 };
$p = $c_Lpresto_types$$anon$103.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$103;
/** @constructor */
function $h_Lpresto_types$$anon$103() {
}
export { $h_Lpresto_types$$anon$103 as $h_Lpresto_types$$anon$103 };
$h_Lpresto_types$$anon$103.prototype = $p;
$p.P = (function() {
  if ((!this.c29)) {
    this.c28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c29 = true;
  }
  return this.c28;
});
var $d_Lpresto_types$$anon$103 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$103, "presto.types$$anon$103", ({
  Y4: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$103 as $d_Lpresto_types$$anon$103 };
//# sourceMappingURL=presto.types$$anon$103.js.map
